import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-app-store-and-rating',
  templateUrl: './app-store-and-rating.component.html',
  styleUrls: ['./app-store-and-rating.component.scss'],
  standalone: false
})
export class AppStoreAndRatingComponent implements OnInit {
  @ViewChild('testimonialContainer', { static: false }) testimonialContainer: ElementRef;
  showMore: boolean = false;

  reviews = [
    {
      name: "Kristin Hester",
      subReview: "Everything simple",
      rating: 4.5,
      stars: "★★★★★",
      review: "Amazing experience with the CarIQ product, especially the app interface which is very smooth. Tracking is precise, and the alerts are timely. We can easily check routes driven by family members. The ignition cut-off feature is really helpful. Great value overall and reliable support post installation."
    },
    {
      name: "T Ray",
      subReview: "Awesome, thank you!",
      rating: 5,
      stars: "★★★★★",
      review: "CarIQ device has been very reliable for me. The ability to monitor trips, fuel efficiency, and rash driving has helped improve safety. The app layout is simple to understand and quick to use. Ignition on/off feature works instantly. Customer service is responsive, making the product worth the price."
    },
    {
      name: "Prashant gupta",
      subReview: "Incredible experience",
      rating: 4.5,
      stars: "★★★★★",
      review: "I have been using this system for a while now and I must say the features are top class. It helps me monitor driving style, vehicle health, and daily trips. The notifications come right on time. The app is lightweight and never slows down. Overall, very happy with the way it works every single day."
    },
    {
      name: "Deva Devaraj",
      subReview: "Unmatched quality",
      rating: 5,
      stars: "★★★★★",
      review: "CarIQ makes tracking very easy and secure. The app keeps logs of all trips which are detailed and useful. Ignition lock provides added security whenever I park. I like that alerts for speed and engine health are accurate. Very professional support staff and overall the device is highly dependable."
    },
    {
      name: "Pavan Teja G",
      subReview: "Incredible experience",
      rating: 4.5,
      stars: "★★★★★",
      review: "Great tracking solution for personal as well as family vehicles. The app provides detailed trip insights and clear notifications. The ignition on/off feature is an extra layer of safety. Very simple to install and start using. I appreciate the responsive service team that explains everything patiently."
    },
    {
      name: "Leonard AM",
      subReview: "Awesome, thank you!",
      rating: 5,
      stars: "★★★★★",
      review: "This product helps me keep complete track of my car on daily basis. From the distance covered to the time spent on trips, everything is shown. Ignition lock and speed alerts give peace of mind. Reports are very informative and easy to understand. Reliable service makes this product even better."
    }
  ];

  // Get visible reviews for mobile (first 3, then show more if needed)
  get visibleReviews() {
    return this.showMore ? this.reviews : this.reviews.slice(0, 3);
  }

  // Get additional reviews for show more functionality
  get additionalReviews() {
    return this.reviews.slice(3);
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  scrollLeft() {
    this.testimonialContainer.nativeElement.scrollBy({
      left: -this.testimonialContainer.nativeElement.offsetWidth,
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.testimonialContainer.nativeElement.scrollBy({
      left: this.testimonialContainer.nativeElement.offsetWidth,
      behavior: 'smooth'
    });
  }

  constructor() { }

  ngOnInit() {
  }

}
